import React from 'react';
import { useIntl } from 'ha/i18n';

import RoundIconButton, {
  RoundIconButtonProps,
} from 'ha/ui/next/RoundIconButton';
import FavoriteIcon from 'streamline-icons/love-it-bold.svg';

interface Props {
  isLoading: boolean;
  isFavorite: boolean;
}

export const FavoriteButtonNext: React.FC<RoundIconButtonProps & Props> = ({
  isFavorite,
  ...props
}) => {
  const { T } = useIntl();

  return (
    <RoundIconButton
      aria-label={isFavorite ? T('Unfavorite') : T('Favorite')}
      title={isFavorite ? T('Unfavorite') : T('Favorite')}
      size="small"
      color="white"
      {...props}
    >
      <FavoriteIcon
        color={isFavorite ? 'error' : 'action'}
        fontSize="inherit"
      />
    </RoundIconButton>
  );
};

FavoriteButtonNext.displayName = 'FavoriteButtonNext';

export default FavoriteButtonNext;
